import { combineReducers, configureStore } from '@reduxjs/toolkit';

import featureToggleReducer, { FEATURE_SLICE_NAME } from '@/configuration/featureToggle/featureToggleSlice';
import langReducer from '@/configuration/lang/langSlice';
import loginReducer from '@/configuration/login/loginSlice';
import tokenReducer from '@/configuration/tokenHandling/tokenSlice';
import appReducer from '@/features/app/appSlice';
import { batteryApi } from '@/features/battery/api/batterySlice';
import { batteryOverviewApi } from '@/features/batteryOverview/api/batteryOverviewSlice';
import batteryOverviewReducer from '@/features/batteryOverview/slices/batteryOverviewSlice';
import configReducer from './configSlice';

const rootReducer = combineReducers({
    config: configReducer,
    lang: langReducer,
    app: appReducer,
    login: loginReducer,
    tokenHandling: tokenReducer,
    batteryOverview: batteryOverviewReducer,
    [batteryApi.reducerPath]: batteryApi.reducer,
    [batteryOverviewApi.reducerPath]: batteryOverviewApi.reducer,
    [FEATURE_SLICE_NAME]: featureToggleReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(batteryApi.middleware, batteryOverviewApi.middleware),
    });
};

export const store = setupStore();

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type RootDispatch = AppStore['dispatch'];
